<template>
    <div class="x-generator" v-if="formStore">
        <x-dynamic :nodeManifest="formStore" />
    </div>
</template>


<script>
import { mapGetters, } from 'vuex';
/**
 *  The x-generator component.
 *  @module components/x-generator
 */

/**
 * The x-generator component is the entry point for dynamic generation of a component hierarchy.
 */
export default {
    name: 'x-generator',
    computed: mapGetters({
        formStore: 'getFormStore',
    }),
};

</script>



// WEBPACK FOOTER //
// source/components/x-generator/x-generator.vue